module.exports = __webpack_public_path__ + "static/2-d415a71005e7a13e5797b6c924fbc964.jpeg";